import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet';

const LanguageSetting = ({ lang }) => {
    const [title, setTitle] = useState('🎶 YouTube MP3 Downloader 🎧');
    const [content, setContent] = useState("🎵 Download your favorite YouTube videos as MP3 files quickly and easily! 🚀");

    useEffect(() => {
        // Set title and content based on the selected language
        switch (lang) {
            case 'en':
                setTitle('🎶 YouTube MP3 Downloader 🎧');
                setContent('🎵 Download your favorite YouTube videos as MP3 files quickly and easily! 🚀');
                break;
            case 'hi':
                setTitle('🎶 YouTube MP3 डाउनलोडर 🎧');
                setContent('🎵 अपने पसंदीदा YouTube वीडियो को MP3 फ़ाइलों के रूप में जल्दी और आसानी से डाउनलोड करें! 🚀');
                break;
            case 'es':
                setTitle('🎶 Descargador de MP3 de YouTube 🎧');
                setContent('🎵 ¡Descarga tus videos favoritos de YouTube como archivos MP3 rápida y fácilmente! 🚀');
                break;
            case 'pt':
                setTitle('🎶 Baixador de MP3 do YouTube 🎧');
                setContent('🎵 Baixe seus vídeos favoritos do YouTube como arquivos MP3 rápida e facilmente! 🚀');
                break;
            case 'ru':
                setTitle('🎶 Загрузчик MP3 с YouTube 🎧');
                setContent('🎵 Загружайте ваши любимые видео с YouTube в формате MP3 быстро и легко! 🚀');
                break;
            case 'uk':
                setTitle('🎶 Завантажувач MP3 з YouTube 🎧');
                setContent('🎵 Завантажуйте улюблені відео з YouTube у форматі MP3 швидко та легко! 🚀');
                break;
            case 'ja':
                setTitle('🎶 YouTube MP3 ダウンローダー 🎧');
                setContent('🎵 お気に入りのYouTube動画をMP3ファイルとして素早く簡単にダウンロードしましょう！🚀');
                break;
            case 'zh':
                setTitle('🎶 YouTube MP3 下载器 🎧');
                setContent('🎵 快速轻松地将您喜爱的视频从YouTube下载为MP3文件！🚀');
                break;
            case 'de':
                setTitle('🎶 YouTube MP3 Downloader 🎧');
                setContent('🎵 Laden Sie Ihre Lieblingsvideos von YouTube schnell und einfach als MP3-Dateien herunter! 🚀');
                break;
            case 'it':
                setTitle('🎶 Scaricatore MP3 di YouTube 🎧');
                setContent('🎵 Scarica i tuoi video preferiti di YouTube come file MP3 in modo rapido e semplice! 🚀');
                break;
            case 'fr':
                setTitle('🎶 Téléchargeur MP3 de YouTube 🎧');
                setContent('🎵 Téléchargez rapidement et facilement vos vidéos YouTube préférées au format MP3 ! 🚀');
                break;
            case 'ar':
                setTitle('🎶 محمّل MP3 من YouTube 🎧');
                setContent('🎵 قم بتنزيل مقاطع الفيديو المفضلة لديك من YouTube كملفات MP3 بسرعة وسهولة! 🚀');
                break;
            case 'id':
                setTitle('🎶 Pengunduh MP3 YouTube 🎧');
                setContent('🎵 Unduh video YouTube favorit Anda sebagai file MP3 dengan cepat dan mudah! 🚀');
                break;
            default:
                break;
        }
    }, [lang]); // Add lang to dependencies

    return (
        <Helmet>
            <html lang={lang} />
            <meta name="description" content={content} />
            <title>{title}</title>
        </Helmet>
    );
};

export default LanguageSetting;
